import { normalizePasskeyEmail } from '../../auth/passkeyDevice';
import type { SavedAccount } from '../../auth/savedAccounts';

export function findSavedAccountByEmail(accounts: SavedAccount[], targetEmail: string): SavedAccount | undefined {
  const normalized = normalizePasskeyEmail(targetEmail);
  return accounts.find((account) => normalizePasskeyEmail(account.email) === normalized);
}

export function setSavedAccountPasskeyFlag(
  accounts: SavedAccount[],
  targetEmail: string,
  hasPasskey: boolean,
): SavedAccount[] {
  const normalized = normalizePasskeyEmail(targetEmail);
  return accounts.map((account) =>
    normalizePasskeyEmail(account.email) === normalized
      ? { ...account, hasPasskey }
      : account
  );
}

export function clearSavedAccountPasskeyFlag(accounts: SavedAccount[], targetEmail: string): SavedAccount[] {
  return setSavedAccountPasskeyFlag(accounts, targetEmail, false);
}
